import { Recipe } from '../types/mealPlan';

/**
 * Recipe list endpoints return summaries: the fields list cards, filters, and
 * sorts use, without ingredients, instructions, or the nutrition breakdown.
 * A summary can seed a first paint (e.g. a list item passed to the details
 * page via navigation state) but must never seed an editor or anything that
 * writes the recipe back, or the missing fields would be saved as empty.
 */
export const isRecipeSummary = (recipe: Recipe): boolean =>
  !Array.isArray(recipe.ingredients) || !Array.isArray(recipe.instructions);

/**
 * Query param that opts a recipe-list request in to summaries. Without it the
 * backend returns full recipes, the shape clients built before summaries
 * expect — so a tab left open across a deploy keeps working. Every list
 * request from this client (which handles summaries) sends it.
 */
export const SUMMARY_VIEW_PARAM = 'view=summary';
